import React, { useState } from "react";
import logo from "../assets/img/logopng.png";
import { ReactComponent as Account } from "../assets/img/account.svg";

import { GoGraph } from "react-icons/go";
import { FaTools } from "react-icons/fa";
import { BiMenuAltLeft } from "react-icons/bi";
import { IoMdBriefcase, IoMdLogOut } from "react-icons/io";

import { BarChart, Server, User, UserCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";
import useLocalStorage from "../Hooks/useLocalStorage";

import Management from "../Components/Management/Management";
import ControlDashboard from "../Components/Analytics/ControlDashboard";
import Services from "../Components/Services/Services";
import { BASE_URL } from "../Config/api.config";
import WorkersPanel from "../Components/Analytics/WorkersPanel";
import EmployersPanel from "../Components/Analytics/EmployersPanel";
import { MdPayment } from "react-icons/md";
import PaymentTransactions from "../Components/payments/PaymentTransactions";
import TicketsAdminDashboard from "src/Components/Tickets/Tickets";
import JobStats from "src/Components/Jobs/JobStats";
import SystemHealth from "src/Components/SystemHealth/SystemHealth";
import { GrSystem } from "react-icons/gr";
export const menuItems = [
  {
    id: "dashboard",
    label: "Analytics",
    icon: <GoGraph className="h-5 w-5 text-white" />,
  },
  {
    id: "workers",
    label: "Workers",
    icon: <UserCheck className="h-5 w-5 text-white" />,
  },
  {
    id: "employers",
    label: "Employers",
    icon: <User className="h-5 w-5 text-white" />,
  },
  {
    id: "management",
    label: "Management",
    icon: <FaTools className="h-5 w-5 text-white" />,
  },
  {
    id: "services",
    label: "Services",
    icon: <Server className="h-5 w-5 text-white" />,
  },
  {
    id: "payments",
    label: "Payments",
    icon: <MdPayment className="h-5 w-5 text-white" />,
  },
  {
    id: "jobs",
    label: "Jobs",
    icon: <IoMdBriefcase className="h-5 w-5 text-white" />,
  },
  {
    id: "tickets",
    label: "Support Tickets",
    icon: <Account className="h-5 w-5 text-white" />,
  },
  {
    id: "system",
    label: "System Health",
    icon: <GrSystem className="h-5 w-5 text-white" />,
  },
];
const AdminDashboard = () => {
  const [selectedTab, setSelectedTab] = useLocalStorage(
    "adminSelectedTab",
    "dashboard"
  );
  const [expanded, setExpanded] = useState(true);
  const [adminData, setAdminData] = useLocalStorage("adminData", "");
  const navigate = useNavigate();

  const formData = new FormData();
  formData.append("id", adminData.id);

  const logout = async () => {
    const response = await fetch(`${BASE_URL}logout`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${adminData.uid}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "ok") {
          setAdminData(null);
          navigate("/");
        } else {
          navigate("/");
        }
      })
      .catch((err) => console.log(err));

    return response;
  };

  return (
    <div className="flex h-screen w-screen">
      {/* Sidebar */}
      <div
        className={`relative h-full bg-gray-900 text-white transition-all duration-300 ${
          expanded ? "w-48" : "w-16"
        } shadow-lg flex flex-col`}
      >
        {/* Toggle button */}
        <button
          className="absolute -right-3 top-4 bg-blue-500 text-white p-1 rounded-full shadow-lg hover:bg-blue-600 transition-colors z-10"
          onClick={() => setExpanded(!expanded)}
        >
          <BiMenuAltLeft className="h-4 w-4" />
        </button>

        {/* Logo */}
        <div className="flex justify-center py-6 mb-6">
          <img src={logo} alt="logo" className="h-10 w-10 rounded-full" />
        </div>

        {/* Navigation items */}
        <div className="flex flex-col items-center space-y-4 flex-grow">
          {menuItems.map((item) => (
            <div
              key={item.id}
              onClick={() => setSelectedTab(item.id)}
              className={`flex items-center transition-all duration-200 group relative cursor-pointer ${
                expanded
                  ? "justify-start px-4 w-full"
                  : "justify-center w-10 h-10"
              } ${
                selectedTab === item.id
                  ? "bg-blue-600 text-white"
                  : "text-gray-300 hover:bg-gray-800 hover:text-white"
              } rounded-lg py-2`}
            >
              <div className="text-xl flex items-center justify-center">
                {item.icon}
              </div>
              {expanded && (
                <span className="ml-3 text-sm font-medium truncate">
                  {item.label}
                </span>
              )}
              {!expanded && (
                <div className="absolute left-12 px-2 py-1 bg-gray-800 text-white text-xs rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
                  {item.label}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom actions */}
        <div className="p-4 border-t border-gray-700 space-y-3">
          <button
            onClick={logout}
            className={`flex items-center transition-all duration-200 text-gray-400 hover:text-white ${
              expanded
                ? "justify-start px-4 w-full"
                : "justify-center w-10 h-10"
            }`}
          >
            <IoMdLogOut className="h-5 w-5" color="white" />
            {expanded && <span className="ml-3 text-sm">Log out</span>}
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className="bg-[#F9F7F7] h-full overflow-auto md:p-4 w-full">
        {selectedTab === "dashboard" && <ControlDashboard />}
        {selectedTab === "management" && <Management />}
        {selectedTab === "services" && <Services />}
        {selectedTab === "workers" && <WorkersPanel />}
        {selectedTab === "employers" && <EmployersPanel />}
        {selectedTab === "payments" && <PaymentTransactions />}
        {selectedTab === "tickets" && <TicketsAdminDashboard />}
        {selectedTab === "jobs" && <JobStats />}
        {selectedTab === "system" && <SystemHealth />}
      </div>
    </div>
  );
};

export default AdminDashboard;
